<template>
	<div class="calendar-container">
		<calendar-header v-bind:month="month" v-bind:year="year" v-on:change-month="changeMonth" />
		<div class="day-container">
			<div class="room-item">
				<span>Nº</span>
			</div>
			<div class="room-item">
				<span>Hab.</span>
			</div>
			<div class="day-item" v-bind:class="{ 'inactive': day.disabled }" v-for="day in days" v-bind:key="day.id">
				<p class="number">{{day.day}}</p>
				<p class="day-text">{{day.dayName}}</p>
			</div>
		</div>
		<div class="day-container" v-for="room in rooms" v-bind:key="room.id">
			<div class="room-item">
				<span>{{room.number}}</span>
			</div>
			<div class="room-item">
				<span>{{room.type}}</span>
			</div>
			<div class="day-item" v-for="maid in room.maids" v-bind:key="maid.id" v-if="!maid.color">
				<avatar-profile v-bind:id="maid.id" class="avatar-margin" v-bind:firstname="maid.firstname"
					v-bind:type-cleaning="maid.typeCleaning" v-bind:time="maid.time"
					v-bind:lastname="maid.lastname" v-bind:color="maid.color" />
			</div>
			<div class="day-item" v-bind:class="{ 'new': !maid.disabled }" v-else>
				<div class="new-icon" v-if="!maid.disabled">
					<button class="btn-add-day" v-on:click.stop="onDayClick(maid, room)">+</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import AvatarProfile from '@/components/shared/AvatarProfile';
import CalendarHeader from './CalendarHeader';

function onDayClick(maid, room) {
	this.$emit('on-add-day', { maid, room });
}

function changeMonth(type) {
	this.$emit('change-month', type);
}

export default {
	name: 'calendar',
	components: {
		AvatarProfile,
		CalendarHeader,
	},
	methods: {
		onDayClick,
		changeMonth,
	},
	props: {
		days: {
			type: Array,
			default: () => [],
		},
		month: {
			type: Number,
			default: 10,
		},
		rooms: {
			type: Array,
			default: () => [],
		},
		year: {
			type: Number,
			default: 2017,
		},
	},
};
</script>

<style lang="scss" scoped>
.calendar-container {
	background-color: #fff;
	padding: 8px 6px;

	.day-container {
		border-bottom: 2px solid map-get($colors, calendar-border);
		border-left: 2px solid map-get($colors, calendar-border);
		display: flex;

		.room-item {
			align-items: center;
			border-right: 2px solid map-get($colors, calendar-border);
			display: flex;
			justify-content: center;
			padding: 9px 7px;
			min-width: 45px;
		}

		.day-item {
			border-right: 2px solid map-get($colors, calendar-border);
			font-family: map-get($fonts, medium);
			flex-basis: 100%;
			font-size: 11px;
			font-weight: bold;
			min-width: 29.8px;
			min-height: 32px;
			padding: 3px 6.2px;
			text-align: center;

			&.new:hover {
				background-color: map-get($colors, button-add);
			}

			.new-icon {
				background-color: white;
				border-radius: 50%;
				height: 100%;
				width: 100%;

				.btn-add-day {
					color: map-get($colors, e-bg-icon);
					font-size: 20px;
					font-weight: bolder;
				}

			}

			.number {
				font-size: 14px;
			}

			p {
				margin: 0;
			}

			&.inactive {
				color: map-get($colors, calendar-text-inactive);
			}

			.avatar-margin {
				margin: auto;
			}

		}

		.new-item {
			background-color: map-get($colors, button-add);

			.btn {
				background-color: white;
				border-radius: 0;
				border: none;
				height: 26px;
				width: 26px;
			}

			&:hover {
				display: block;
			}

			.new-item-icon {
				align-items: center;
				background-color: white;
				border-radius: 50%;
				display: flex;
				justify-content: center;
				height: 100%;
				width: 100%;
			}
		}

	}

}
</style>


// WEBPACK FOOTER //
// Calendar.vue?1d7f9ba8